export const GET_ALL_INGREDIENTS_SUCCESS: 'GET_ALL_INGREDIENTS_SUCCESS' = 'GET_ALL_INGREDIENTS_SUCCESS';
export const GET_ALL_INGREDIENTS_ERROR: 'GET_ALL_INGREDIENTS_ERROR' = 'GET_ALL_INGREDIENTS_ERROR';
export const GET_ALL_INGREDIENTS_PENDING: 'GET_ALL_INGREDIENTS_PENDING' = 'GET_ALL_INGREDIENTS_PENDING';